'use strict';
var $RangeError = RangeError;

module.exports = function (it) {
  // eslint-disable-next-line no-self-compare -- NaN check
  if (it === it) return it;
  throw new $RangeError('NaN is not allowed');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/not-a-nan.js
// module id = 373
// module chunks = 111